import { render, staticRenderFns } from "./imgPage.vue?vue&type=template&id=6ed7c83a&scoped=true&"
import script from "./imgPage.vue?vue&type=script&lang=js&"
export * from "./imgPage.vue?vue&type=script&lang=js&"
import style0 from "./imgPage.vue?vue&type=style&index=0&id=6ed7c83a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7c83a",
  null
  
)

export default component.exports